import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { ProvidersService } from '../../../services/providers.service';
import { ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';
import { ProviderModalComponent } from '../provider-modal/provider-modal.component';
import { ProviderCompaniesComponent } from '../provider-companies/provider-companies.component';


import { ProviderComponent } from '../provider/provider.component';
import * as XLSX from 'xlsx';
import * as decode from 'jwt-decode';

// tslint:Insert-next-line: IN_HCR20200831
import { TranslateService } from 'ng2-translate/ng2-translate';

@Component({
  selector: 'app-providers',
  templateUrl: './providers.component.html',
  styleUrls: ['./providers.component.scss']
})
export class ProvidersComponent implements OnInit {
  userId: any;
  userToken: any;
  listPproviders = [];
  userData: any;
  temp = [];
  load = true;
  loadBtn = false;

  constructor(private toastr: ToastrService,
              public dialog: MatDialog,
              private gralService: GeneralService,
              private provService: ProvidersService,
              private router: Router,

              // tslint:insert-next-line: IN_HCR20200831
              public  translate: TranslateService) {
                translate.addLangs(['es', 'en']);
                translate.setDefaultLang('es');
               // tslint:insert-next-line: END_HCR20200831

                this.userData = decode(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352'));
                this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
                const d = this.userToken.split('Bearer ');
                const tokenPayload = decode(d[1]);
                this.userId = tokenPayload.Id;
                gralService.changeTextHead('PROVIDERSCAT');
                this.getProviders();
  }

  ngOnInit() {


  }

  getProviders(){
    this.provService.getProviders(this.userToken).then((data) => {
      this.listPproviders = data['Entidades'];
      this.temp = data['Entidades'];

      this.load = false;
      this.reorderList();
    }, (err) => {
      console.log(err);
      this.listPproviders = null;
      this.load = false;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  updateFilter(event) {

    const val = event.target.value.toLowerCase();
    // filter our data
    const temp = this.temp.filter(function(d) {

      let ret = d.Proveedor.Nombre.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.Proveedor.RFC.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.Proveedor.NumerosProveedores.indexOf(val) !== -1 || !val;

      return ret;
    });
    // update the rows
    this.listPproviders = temp;
  }

  edit(id, idx){
    //this.router.navigate(['admin/proveedor', id]);

    this.dialog.open(ProviderComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'difference', provider: id  }
    });

  }

  getDiff(id){
    this.provService.getProviderDifference(id, this.userToken).then((data) => {
      this.dialog.open(ProviderModalComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: {type: 'difference', provider: id, info: data['Entidad']}
      });
    }, (err) => {
      console.log(err);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  getSocieties(id) {
    this.provService.getProvider(id, this.userToken).then((data) => {
      this.dialog.open(ProviderCompaniesComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: { type: 'companies', provider: id, info: data['Entidad'] }
      });
    }, (err) => {
      console.log(err);
      if (err.status == 401) {
        this.gralService.actDeacUser(false);
      }
    });
  }

  changeStatus(id, status, idx){
    let dataa = {};
    if(!status){
      //IN_HCR20200831
      //dataa = { type: 'delete', id: id, button: 'Desactivar', title: 'Desactivar proveedor'  , content: '¿Esta seguro de desactivar este proveedor?', icon: 'warning' };
      dataa = { type:     'delete', id: id,
                button:   this.translate.instant('BUTTONS.DEACTIVATE') ,
                title:    this.translate.instant('FORMS.DESPRO'),
                content:  this.translate.instant('FORMS.CONDESPRO'),
                icon: 'warning' };
                //END_HCR20200831
    }else{
      //
      dataa = { type: 'active',
                id: id,
              //IN_HCR20200831
               // button: 'Activar',
               //title: 'Activar proveedor',
               //content: '¿Esta seguro de activar este proveedor?',
               button:  this.translate.instant('BUTTONS.ACTIVATE'),
               title:   this.translate.instant('FORMS.ACTPRO'),
               content: this.translate.instant('FORMS.CONACTPRO'),
               icon: 'warning' };
               //END_HCR20200831

    }


    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: dataa
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.loadBtn = true;
        console.log(this.listPproviders[idx].Proveedor);
        this.provService.updateProvider(id, {Proveedor: {Active: status,RFC:this.listPproviders[idx].Proveedor.RFC,Nombre:this.listPproviders[idx].Proveedor.Nombre}}, this.userToken).then((data) => {
          this.loadBtn = false;
          this.listPproviders[idx].Proveedor.Activo = status;
        }, (err) => {
          console.log(err);
          this.loadBtn = false;
          this.toastr.error(err['error'].msg, 'Error al cambiar estatus de proveedor');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    });
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listProviders);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('proveedores'));
  }

  listProviders = [];
  reorderList(){
    this.listProviders = [];
    let lista = this.listPproviders;

    for(let i = 0; i < lista.length; i++){
      let s60 = [];
      let s10 = [];

      if( lista[i].Sociedades ){
        let sociedad = lista[i].Sociedades;
        if(sociedad.length > 0){
          for(let x = 0; x < sociedad.length; x++){
            //console.log(sociedad[x])
            if(sociedad[x].NoSociedad == 'S010' ){
              s10.push(sociedad[x].NumeroProveedor);
            }

            if(sociedad[x].NoSociedad == 'S060' ){
              s60.push(sociedad[x].NumeroProveedor);
            }
          }
        }
      }

      let params = {
        "Razón social": lista[i].Proveedor.Nombre,
        "Email": lista[i].Proveedor.Email,
        "RFC": lista[i].Proveedor.RFC,
        "No. Proveedor S060": (s60.length>0) ? s60.join() :'',
        "No. Proveedor S010": (s10.length>0) ? s10.join() :'',
        "Estatus": (lista[i].Proveedor.Activo)?'Activo': 'Inactivo'
    }

    this.listProviders.push(params);
    }

  }
}
